export const EMAIL_ERROR = 'email'
export const ENGLISH_LANGUAGE_COUNTRIES = ['uk', 'us', 'au', 'ie', 'nz', 'ca']
export const DUTCH_LANGUAGE_COUNTRIES = ['nl', 'be']
export const GERMAN_LANUAGE_COUNTRIES = ['de', 'at']
export const GOOGLE_LANGUAGE_CODES = new Map([
  ['en', ENGLISH_LANGUAGE_COUNTRIES],
  ['fr', 'fr'],
  ['de', GERMAN_LANUAGE_COUNTRIES],
  ['nl', DUTCH_LANGUAGE_COUNTRIES],
  ['es', 'es'],
  ['it', 'it'],
  ['sv', 'se'],
  ['da', 'dk'],
  ['pl', 'pl'],
  ['zh-CN', 'cn']
])

export const PERSONAL_EMAIL_FALLBACK =
  'Please use your personal email, not your student email'

export const RECAPTCHA_ERROR_TEXT = 'Recaptcha is invalid, please try again'
export const RECAPTCHA_ERROR = 'RECAPTCHA FAILED'
